const randomInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
const clamp = (a: number, min = 0, max = 1) => Math.min(max, Math.max(min, a));
const lerp = (x: number, y: number, a: number) => x * (1 - a) + y * a;
const range = (x1: number, y1: number, x2: number, y2: number, a: number) => lerp(x2, y2, invlerp(x1, y1, a));
const invlerp = (x: number, y: number, a: number) => clamp((a - x) / (y - x));
const radiansToDegrees = (radians: number) => (radians * 180) / Math.PI;
const smoothstep = (value: number) => value * value * (3 - 2 * value);
const easeInOutCubic = (t: number) => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2);

export { clamp, easeInOutCubic, invlerp, lerp, radiansToDegrees, randomInt, range, smoothstep };
